export function removeFalsyKeys<T>(obj: Record<string, T | null>): Record<string, T>;
export function removeFalsyKeys(obj: object): {[p: string]: any};
export function removeFalsyKeys(obj: object) {
  return Object.fromEntries(Array.from(Object.entries(obj)).filter(([, value]) => !!value));
}
